import { render, staticRenderFns } from "./courseDataPartner.vue?vue&type=template&id=70ea888d&scoped=true"
import script from "./courseDataPartner.vue?vue&type=script&lang=js"
export * from "./courseDataPartner.vue?vue&type=script&lang=js"
import style0 from "./courseDataPartner.vue?vue&type=style&index=0&id=70ea888d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea888d",
  null
  
)

export default component.exports